export const asArray = (value) => (Array.isArray(value) ? value : []);
